/**
 * Shader language belongs to.
 */
export enum ShaderLanguage {
  /** GLSL ES 100. */
  GLSLES100,

  /** GLSL ES 300. */
  GLSLES300
}
